import { FunctionComponent, useEffect, useState } from "react"
import { a, useTrail } from 'react-spring'
import { SiGithub, SiLinkedin, SiGmail } from "react-icons/si";
import '../../App.scss';

interface Props {
  activeScene: number
  width: number
  breakpoint: number
}

const WhoAmI: FunctionComponent<Props> = (props) => {
  const { width, breakpoint } = props
  
  const [open, set] = useState(false) 
  const items = [0, 1, 2, 3, 4, 5]
  const trail = useTrail(items.length, {
    config: { mass: 4, tension: 1400, friction: 200 },
    opacity: open ? 1 : 0,
    x: open ? 0 : 80,
    minus_x: open ? 0 : -80
  })

  const handleIconClick = (link: string) => {
    window.open(link);
  }

  useEffect(() => {
    set(props.activeScene === 0)
  }, [props.activeScene])

  return(
    <div className="subject-canvas who-am-i">
      <div className="container">
        <div className="left-container">
          <div className="text-container">
            <div>
              <a.div className="name-text" style={{ marginBottom: 0, opacity: trail[0].opacity, x: trail[0].x }}>I'm</a.div>
              <a.div className="name-text" style={{ marginBottom: 0, opacity: trail[1].opacity, x: trail[1].x  }}>Guilherme</a.div>
              <a.div className="name-text" style={{ opacity: trail[2].opacity, x: trail[2].x  }}>Schoueri</a.div>
              <a.div className="about-text" style={{ marginBottom: "2ch", opacity: trail[3].opacity, x: trail[3].x }}>Motivated to develop creative solutions for meaningful problems</a.div>
              <a.div className="about-text-small" style={{ marginBottom: "4ch", opacity: trail[4].opacity, x: trail[4].x }}>Computer Engineering student at Insper, São Paulo</a.div>
              <a.div className="link-icon-group" style={{ opacity: trail[5].opacity, x: trail[5].x }}>
                <SiGithub className="link-icon" size="2ch" onClick={() => handleIconClick("https://github.com/guigs10mil")} />
                <SiLinkedin className="link-icon" size="2ch" onClick={() => handleIconClick("https://linkedin.com/in/guilhermeschoueri")} />
                <SiGmail className="link-icon" size="2ch" target="_blank" onClick={() => handleIconClick("mailto:guilhermeschoueri@gmail.com?subject=Hi!%20Cool%20portfolio!")} />
                <div className="about-text-small selectable" style={{ textAlign: "center" }}>guilhermeschoueri@gmail.com</div>
              </a.div>
            </div>
          </div>
        </div>
        {width > breakpoint
          ? (
            <>
              <div style={{ width: "10vw", minWidth: "60px", maxWidth: "300px" }} />
              <div style={{ height: "40rem", justifyContent: "center", alignItems: "center" }}>
                <a.img
                  src={process.env.PUBLIC_URL + '/portfolio.jpg'}
                  style={{
                    x: trail[3].minus_x,
                    opacity: trail[3].opacity,
                    height: "100%",
                    borderRadius: "1ch",
                    filter: "grayscale(1)"
                  }}
                />
              </div>
            </>
          ) : null
        }
      </div>
    </div>
  )
}

export { WhoAmI }